export default "__VITE_ASSET__Ki6PhM57__"